/** Shown when a participant or invite email fails format validation. */
export const INVALID_EMAIL_MESSAGE =
  'Enter a valid email address (for example, name@company.com).'

/**
 * Domain must include a label and TLD (e.g. company.com), matching common product rules.
 */
const EMAIL_DOMAIN_TLD_PATTERN =
  /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/

/** Fallback when `document` is unavailable (tests, SSR). */
const EMAIL_FALLBACK_PATTERN = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}(?:\.[A-Za-z]{2,})*$/

function passesHtml5EmailInputRules(email) {
  if (typeof document === 'undefined') {
    return EMAIL_FALLBACK_PATTERN.test(email)
  }
  const input = document.createElement('input')
  input.type = 'email'
  input.required = true
  input.value = email
  return input.checkValidity()
}

function hasValidEmailDomain(email) {
  const at = email.lastIndexOf('@')
  if (at < 1 || at === email.length - 1) return false
  return EMAIL_DOMAIN_TLD_PATTERN.test(email.slice(at + 1))
}

/**
 * Validates email format using HTML5 `type=email` rules plus a domain TLD requirement.
 */
export function isValidEmail(value) {
  const trimmed = String(value ?? '').trim()
  if (!trimmed || trimmed.length > 254) return false
  if (!passesHtml5EmailInputRules(trimmed)) return false
  return hasValidEmailDomain(trimmed)
}
